import { MutationTree } from 'vuex'
import { Mutations, UiState } from '@/store/ui/types'

export default <MutationTree<UiState>>{
  [Mutations.SET_IS_FUNNEL_SAVE_STOP_OPEN]: (state, value) => {
    state.isFunnelSaveStepOpen = value
  },
}
